import { render } from "./Holder.vue?vue&type=template&id=585b2a8f&scoped=true&ts=true"
import script from "./Holder.vue?vue&type=script&lang=ts"
export * from "./Holder.vue?vue&type=script&lang=ts"

import "./Holder.vue?vue&type=style&index=0&id=585b2a8f&scoped=true&lang=scss"
import "./Holder.vue?vue&type=style&index=1&id=585b2a8f&lang=css"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585b2a8f"]])

export default __exports__